import { memo, useCallback } from 'react';

import MultiSelectField from '../../../common/fields/MultiSelectField';
import SectionCard from './SectionCard';

export default memo(function TeachingSection({
  formData,
  errors = {},
  subjectOptions,
  mediumOptions,
  classTypeOptions,
  cityOptions,
  onChange,
}) {
  const handleSubjectsChange = useCallback((s) => onChange({ subjects: s }), [onChange]);
  const handleMediumChange = useCallback((m) => onChange({ medium: m }), [onChange]);
  const handleClassTypesChange = useCallback((t) => onChange({ classTypes: t }), [onChange]);
  const handleCitiesChange = useCallback((c) => onChange({ cities: c }), [onChange]);

  return (
    <SectionCard title="Teaching Information">
      <div className="space-y-4">
        <MultiSelectField
          label="Subjects"
          value={formData.subjects}
          onChange={handleSubjectsChange}
          options={subjectOptions}
          error={!!errors.subjects}
          helperText={errors.subjects}
        />
        <MultiSelectField
          label="Medium of Teaching"
          value={formData.medium}
          onChange={handleMediumChange}
          options={mediumOptions}
          error={!!errors.medium}
          helperText={errors.medium}
        />
        <MultiSelectField
          label="Class Types"
          value={formData.classTypes}
          onChange={handleClassTypesChange}
          options={classTypeOptions}
          error={!!errors.classTypes}
          helperText={errors.classTypes}
        />
        <MultiSelectField
          label="Cities"
          value={formData.cities}
          onChange={handleCitiesChange}
          options={cityOptions}
          error={!!errors.cities}
          helperText={errors.cities}
        />
      </div>
    </SectionCard>
  );
});
